/* This file is autogenerated, see readme.md for instructions */
import ProductSlotsSvgIcon from '@bloomreach/banana-theme/icons/product-slots.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ProductSlotsIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ProductSlotsSvgIcon />
    </Icon>
  );
});

ProductSlotsIcon.displayName = 'ProductSlotsIcon';

export default ProductSlotsIcon;
